/**
 * StatCard - 통계 정보 카드 컴포넌트
 */
import React from 'react';
import './StatCard.css';

interface StatCardProps {
  label: string;
  value: string | number;
  className?: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, className = '' }) => {
  return (
    <div className={`stat-card ${className}`}>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
    </div>
  );
};

export default StatCard;
